/**
 * FE PARTS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getFeParts,
    getFePart,
    printFePart,
    createFeParts,
    updateFeParts,
    deleteFeParts,
    uploadFePartImage,
    deleteFePartImage,
} from "Modules/inventory/fe_parts/config/api.fe_parts";

const state = {
    page: {},
    form: {},
    fe_parts: [],
    fe_part_options: [],
    fe_part_options_by_vendor: [],
    selectedFePart: {
        part_id: null,
        company_id: "",
        fe_part_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        fe_part_details: [],
    },
    fe_parts_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
        exact_match: "0",
        tag: null,
    },
    rules_fe_parts: {
        part_id: {
            name: "part_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        file_id: {
            name: "file_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        name: {
            name: "name",
            rules: "trim|max_length[255]|required",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        is_service: {
            name: "is_service",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        is_global: {
            name: "is_global",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        web_url: {
            name: "web_url",
            rules: "trim|max_length[255]|valid_url",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        hts_code: {
            name: "hts_code",
            rules: "trim|max_length[10]",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        part_assembly: {
            name: "part_assembly",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        mfg_id: {
            name: "mfg_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        model_number: {
            name: "model_number",
            rules: "trim|max_length[255]|required",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        purchase_account_id: {
            name: "purchase_account_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        purchase_sku: {
            name: "purchase_sku",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        purchase_description: {
            name: "purchase_description",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        purchase_unit: {
            name: "purchase_unit",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        purchase_unit_weight: {
            name: "purchase_unit_weight",
            rules: "trim|max_length[11]|decimal|required",
            max_len: "10",
            min_len: "",
            default_value: "0.000",
        },
        sales_unit_weight_measure_id: {
            name: "sales_unit_weight_measure_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        part_cost: {
            name: "part_cost",
            rules: "trim|max_length[16]|decimal|required",
            max_len: "15",
            min_len: "",
            default_value: "0.000",
        },
        lead_time: {
            name: "lead_time",
            rules: "trim|max_length[3]|integer",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        sales_account_id: {
            name: "sales_account_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        sales_sku: {
            name: "sales_sku",
            rules: "trim|max_length[36]|required",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        sales_description: {
            name: "sales_description",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        sales_unit: {
            name: "sales_unit",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        sales_unit_weight: {
            name: "sales_unit_weight",
            rules: "trim|max_length[11]|decimal|required",
            max_len: "10",
            min_len: "",
            default_value: "0.000",
        },
        sales_markup: {
            name: "sales_markup",
            rules: "trim|max_length[3]|integer|required",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        sales_price: {
            name: "sales_price",
            rules: "trim|max_length[16]|decimal|required",
            max_len: "15",
            min_len: "",
            default_value: "0.000",
        },
        is_taxable: {
            name: "is_taxable",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        is_trackable: {
            name: "is_trackable",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        inventory_account_id: {
            name: "inventory_account_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        stock_reorder_point: {
            name: "stock_reorder_point",
            rules: "trim|max_length[25]|integer",
            max_len: "25",
            min_len: "",
            default_value: "",
        },
        stock_bin_number: {
            name: "stock_bin_number",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        stock_quantity: {
            name: "stock_quantity",
            rules: "trim|max_length[11]|integer",
            max_len: "11",
            min_len: "",
            default_value: "",
        },
        order_quantity: {
            name: "order_quantity",
            rules: "trim|max_length[15]|integer",
            max_len: "11",
            min_len: "",
            default_value: "",
        },
        opening_stock: {
            name: "opening_stock",
            rules: "trim|max_length[11]|integer",
            max_len: "11",
            min_len: "",
            default_value: "",
        },
        opening_stock_cost_per_unit: {
            name: "opening_stock_cost_per_unit",
            rules: "trim|max_length[15]|decimal|",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        active: {
            name: "active",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
        archive: {
            name: "archive",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
        is_raw_material: {
            name: "is_raw_material",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        is_non_stock: {
            name: "is_non_stock",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        stock_reorder_quantity: {
            name: "stock_reorder_quantity",
            rules: "trim|max_length[8]|integer",
            max_len: "11",
            min_len: "",
            default_value: "",
        },
        old_control_number: {
            name: "old_control_number",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        notes: {
            name: "notes",
            rules: "trim|max_length[65535]",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        fe_part_vendor_mapping: {
            vendor_id: {
                name: "vendor_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            sku: {
                name: "sku",
                rules: "trim|max_length[50]|required",
                max_len: "50",
                min_len: "",
                default_value: "",
            },
            unit_price: {
                name: "unit_price",
                rules: "trim|max_length[16]|decimal|required",
                max_len: "15",
                min_len: "",
                default_value: "0.000",
            },
            purchase_unit: {
                name: "purchase_unit",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            purchase_unit_weight: {
                name: "purchase_unit_weight",
                rules: "trim|max_length[11]|decimal|required",
                max_len: "10",
                min_len: "",
                default_value: "0.000",
            },
            purchase_unit_weight_measure_id: {
                name: "purchase_unit_weight_measure_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            lead_time: {
                name: "lead_time",
                rules: "trim|max_length[3]|integer",
                max_len: "3",
                min_len: "",
                default_value: "",
            },
            prime: {
                name: "prime",
                rules: "trim|max_length[1]|integer",
                max_len: "1",
                min_len: "",
                default_value: "",
            },
            is_active: {
                name: "is_active",
                rules: "trim|max_length[1]|integer|required",
                max_len: "1",
                min_len: "",
                default_value: "1",
            },
        },
        fe_part_category_mapping: {
            category_id: {
                name: "category_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    fe_parts: (state) => {
        return state.fe_parts;
    },
};

// actions
const actions = {
    async fetchFeParts({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getFeParts({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageFeParts", response.data.page);
                }

                if (body.options) {
                    if (body.by_vendor) {
                        commit("setFePartOptionsByVendor", response.data.fe_parts);
                    } else {
                        commit("setFePartOptions", response.data.fe_parts);
                    }
                } else {
                    commit("setFeParts", response.data.fe_parts);
                }
                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchFePart({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getFePart(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedFePart", response.data.fe_part);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printFePart({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printFePart(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveFePart({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["part_id"] === "undefined" || body["part_id"] == null || body["part_id"] == "") {
                delete body["part_id"];
                response = await createFeParts({ body: body, headers: config.headers });
            } else {
                let part_id = body["part_id"];
                delete body["part_id"];
                response = await updateFeParts({ body: body, headers: config.headers }, part_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log(response);
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async postFePartImage({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            let part_id = body["part_id"];
            delete body["part_id"];
            response = await uploadFePartImage({ body: body, headers: config.headers }, part_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async removeFePartImage({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            let part_id = body["part_id"];
            let file_id = body["file_id"];
            response = await deleteFePartImage(part_id, file_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteFePart({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteFeParts(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageFeParts(state, page) {
        state.page = page;
    },
    setFeParts(state, fe_parts) {
        state.fe_parts = fe_parts;
    },
    setFePartOptions(state, fe_parts) {
        state.fe_part_options = fe_parts;
    },
    setFePartOptionsByVendor(state, fe_parts) {
        state.fe_part_options_by_vendor = fe_parts;
    },
    setSelectedFePart(state, fe_part) {
        state.selectedFePart = fe_part;
    },
    resetSelectedFePart(state) {
        for (const key in state.selectedFePart) {
            if (key in state.rules_fe_parts) {
                state.selectedFePart[key] = state.rules_fe_parts[key].default_value == "null" ? null : state.rules_fe_parts[key].default_value;
            }
        }
    },
    resetFeParts(state) {
        state.page = {};
        state.form = {};
        state.fe_parts = [];
        state.fe_part_options = [];
        state.fe_part_options_by_vendor = [];
        state.selectedFePart = {
            part_id: null,
            company_id: "",
            fe_part_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            fe_part_details: [],
        };
        state.fe_parts_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
            exact_match: "0",
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
